import APIClient from './apiClient.js';

import {
  DeepAssign,
  deepAssign,
  deepAssignWithConcat,
  deepAssignWithOverwrite,
  deepAssignWithShallowMerge,
} from './deepAssign.js';

import deferred from './deferred.js';
import EventsHub from './eventsHub.js';
import extendPromise from './extendPromise.js';

import {
  resource,
  resourceCreator,
  resourcesCollection,
  provider,
  providerCreator,
  providers,
  proxyContainer,
} from './jimpleFns.js';

import ObjectUtils from './objectUtils.js';

export { APIClient, DeepAssign, deepAssign, deepAssignWithConcat, deepAssignWithOverwrite, deepAssignWithShallowMerge, deferred, EventsHub, extendPromise, resource, resourceCreator, resourcesCollection, provider, providerCreator, providers, proxyContainer, ObjectUtils };
